/// <reference path='../types/global.d.ts' />
import { KJUR, KEYUTIL } from 'jsrsasign';
import { getCookie, deleteCookie, setCookie } from './cookies';
import { IUser } from '@enginuity-common/types/user';

const wKJUR = window.KJUR || KJUR;
const wKEYUTIL = window.KEYUTIL || KEYUTIL;

const AUTH_ORIGIN_COOKIE_NAME = 'enginuity-auth-origin';

export type Token = {
  aud: string;
  cid: string;
  exp: number;
  iat: 1614178534
  iss: string;
  jti: string;
  scp?: string[];
  sub: string;
  uid: string;
  ver: number;
  firstName: string;
  lastName: string;
};

export type GroupsClaim = {
  groups?: string[];
};

export type EalCentreClaim = {
  centre?: string;
  centreid?: string;
};

export function getStoredToken<T extends Token>(): T | null {
  const token = getCookie('enginuity-sp-token');
  const tokenKey = getCookie('enginuity-sp-token-key') || '{}';

  if (!token || !tokenKey || tokenKey === '{}') {
    return null;
  }
  
  const key = wKEYUTIL.getKey(JSON.parse(tokenKey));

  const tokenIsValid = wKJUR.jws.JWS.verifyJWT(token, key, {
    alg: ['RS256']
  });

  if (tokenIsValid) {
    const parsed = JSON.parse(wKJUR.jws.JWS.parse(token).payloadPP) as T;
    return parsed;
  }

  return null;
}

export function removeStoredToken() {
  deleteCookie('enginuity-sp-token');
  deleteCookie('enginuity-sp-token-key');
}

export const isSignedIn = () => {
  const token = getCookie('enginuity-sp-token');

  if (!token) {
    return false;
  }

  const tokenKey = JSON.parse(getCookie('enginuity-sp-token-key') || '{}');
  return wKJUR.jws.JWS.verifyJWT(token, wKEYUTIL.getKey(tokenKey), {
    alg: ['RS256']
  });
};

export function redirectUserForAuthentication() {
  setCookie(AUTH_ORIGIN_COOKIE_NAME, window.location.pathname, 1);
  window.location.href = '/auth';
}

export function redirectUserForSignIn() {
  const authOrigin = getCookie(AUTH_ORIGIN_COOKIE_NAME);
  const locationOrigin = `${window.location.protocol}//${
    window.location.hostname
  }${window.location.port ? ':' + window.location.port : ''}${authOrigin}`;
  window.location.href = `${window.spConfig.signInUrl}?fromURI=${locationOrigin}`;
}

export const mapUser = (user?: any): IUser => {
  if (user && user.profile) {
    user.profile.ageRange = user.profile.agerange;
    delete user.profile.agerange;
  }
  return user;
};
